/**
 * @ Author: Zhang Yujun
 * @ Create Time: 2025-01-23 09:20:01
 * @ Modified by: Zhang Yujun
 * @ Modified time: 2025-01-23 09:34:06
 * @ Description:
 */

import axios from 'axios'
import CONFIG from './config'
import { setStorage, getStorage } from '@/utils/storage'

axios.defaults.baseURL = CONFIG.API_URL
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// axios 拦截器配置

// 减少一层层级
axios.interceptors.response.use(config => {
  // 登录过期操作
  if (config.data.code === 21300 || config.data.code === 10001) {
    if (getStorage().token) {
      setStorage({
        phone: '',
        userId: '',
        token: ''
      })
      location.reload()
      return
    }
  }
  return config.data
})

export default axios
